import {FACTIONS} from "../../../constants/factions";

export const CELECTIALS_QUOTES = [{
  quote: 'Судьба толкает кости. Мы толкаем судьбу',
  author: 'Флавия Ориген, селестиал-префект Эфирных когор',
  factionId: FACTIONS.CELECTIALS
}, {
  quote: 'Ваша случайность — наша предрешённость',
  author: 'Аврелий Клавдиан, верховный селестиал-авгур Неотвратимого',
  factionId: FACTIONS.CELECTIALS
}, {
  quote: 'Летать над полем боя — значит видеть всё. Видеть всё — значит никогда не ошибаться',
  author: 'Секст Ноний Фульгур, селестиал-квестор Ясного неба',
  factionId: FACTIONS.CELECTIALS
}, {
  quote: 'Судьба — это поток. А мы — камни в этом потоке, которые выбирают, кого раздавить',
  author: 'Публий Атрацин, селестиал-магистр Фатум-легионов',
  factionId: FACTIONS.CELECTIALS
}, {
  quote: 'Неудачи не бывают случайными',
  author: 'Гай Ветий Стелла, селестиал-трибун Предопределенных маршрутов',
  factionId: FACTIONS.CELECTIALS
}, {
  quote: 'Удача — это дар. Но мало кто из вас его достоин',
  author: 'Спурий Неменор, децемвир Вышнего совета селестиалов',
  factionId: FACTIONS.CELECTIALS
}, {
  quote: 'Нет более подлого врага, чем ненадежный друг. Конечно, если не брать в расчет темных эльфов',
  author: 'Сервий Планк, селестиал-магистр Безветренных высот',
  factionId: FACTIONS.CELECTIALS
}]